import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getLoggedOutFallbackLocales, getLoggedOutConfigFor } from '@cbhq/intl';
import { GLOBAL_EDITION_CODE } from '../constants.js';
import messages from '../messages.js';
function useDisplayDetails(countryCode, languageCode, localeCodeToDisplayName, localeFromUrl) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return useMemo(() => {
    if (countryCode === GLOBAL_EDITION_CODE) {
      const lowerCaseLocaleFromUrl = localeFromUrl.toLowerCase();

      // we make the check case-insensitive because the same locale can be written in different cases
      const localeFromList = getLoggedOutFallbackLocales().find(locale => locale.toLowerCase() === lowerCaseLocaleFromUrl);
      if (localeFromList && localeFromList in localeCodeToDisplayName) {
        return {
          countryName: formatMessage(messages.globalLabel),
          languageName: localeCodeToDisplayName[localeFromList]
        };
      }
    }
    const countryConfig = getLoggedOutConfigFor(countryCode);
    if (countryConfig) {
      const countryName = countryConfig.country_name,
        supportedLocales = countryConfig.supported_locales;
      const langItem = supportedLocales.find(locale => locale.tag === languageCode);
      return {
        countryName,
        languageName: langItem?.name
      };
    }

    // This is case where the country is not yet supported in loc-2 (ie, rest of world)
    return {
      countryName: formatMessage(messages.globalLabel),
      languageName: localeCodeToDisplayName[languageCode]
    };
  }, [countryCode, formatMessage, languageCode, localeCodeToDisplayName, localeFromUrl]);
}
export { useDisplayDetails };
//# sourceMappingURL=useDisplayDetails.js.map
